var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.document)?_c('div',{style:(_vm.selfStyle)},[_c('span',{staticClass:"tooltip-up",class:_vm.spanClass,attrs:{"data-placement":"top","title":_vm.tooltipTitle,"data-toggle":"tooltip"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }